import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { LoyaltyApi } from "../../services";
import { BrowserStorage, User } from "../../utils";

const user = new User(new BrowserStorage());

export const useUsersPointsBalance = () => {
  const { uuid, ciam_token } = user.getUser();

  return useQuery(QUERY_KEYS.usersPointsBalance, async () => {
    const loyaltyApi = LoyaltyApi.init();
    const status = await loyaltyApi.getStatus();
    if (uuid && ciam_token && status) {
      return await loyaltyApi.getPoints(uuid, ciam_token);
    }
  });
};
